import { render, staticRenderFns } from "./SynchronousProducts.vue?vue&type=template&id=7d8ad4c2&scoped=true"
import script from "./SynchronousProducts.vue?vue&type=script&lang=js"
export * from "./SynchronousProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8ad4c2",
  null
  
)

export default component.exports